<template>
     <table ref="table_container" class="generated-datatables"/>
</template>

<script>
    import {translatePrj} from "classes/vue-dict-filter";
    import {capitalizeFirstLetter} from "classes/helpers";

    import FlyerlineModal from "fragments/FlyerlineModal";
    import SkyFormLoader from "fragments/SkyFormLoader";

    import {addressTextFields } from 'components/versandaufteilung/TextAddress'


    const prefix = 'versandaufteilung';

    function getTitle(name) {
        return translatePrj(prefix + capitalizeFirstLetter(name)) || "";
    }

    export default {
        name: "AddressBookTable",
        components: {FlyerlineModal, SkyFormLoader},
         props: { addresses: Array },
        created() {
            this.allFields = [...addressTextFields, 'country'];
             const columns = [{name: 'DT_RowId', visible: false}]
               columns.push({title: "", name:"edit"})
             for (const name of this.allFields) {
                  columns.push({title: getTitle(name), name})
             }
           
             this.columns = columns
        },

         computed: {
            opts() {
               return {
                    data: [],
                    columns: this.columns,
                    responsive: {
                         details: {
                              type: 'column',
                              target: -1
                         }
                    },
                    paging: true,
                    info: false,
                    order: [[0, "desc"]],
                    columnDefs: [
                         {targets: -1, orderable: false, className: 'control'},
                         {targets: 'nosort', orderable: false},
                         {responsivePriority: 1, targets: 6}
                    ],
                    language: {
                         searchPlaceholder: dictDataTableAddressSearchfield,
                         zeroRecords: dictDataTableMatchingFound,
                         paginate: {
                              next: dictDataTableNext,
                              previous: dictDataTablePrevious
                         }
                    },
                    scrollY: 350,
                    deferRender: true,
                    scroller: true

               }

            }
        },
        mounted() {
            // Accessing subcomponents in this is the absolute exception
            // This is only necessary due to need to use datatables
            // table.find('tbody').on('click', 'a.js-prepareorder-edit-address', function (event) {
            // ,

               
               const tableContainer = this.$refs.table_container;
               setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                    var thSecond = document.getElementsByClassName("sorting")[1];
                    thSecond.dispatchEvent(new Event('click'));
               }, 1000);

               this.dataTable = jQuery(tableContainer).DataTable(this.opts)
               jQuery(tableContainer).find('tbody').on('click', 'td', (ev) => {
                    const td = ev.currentTarget
                    const col = this.dataTable.column(td)
                    const row = this.dataTable.row(td)
                    //TODO: add selection
                    const c_index = col.index()
                    // By Convenction last column is the edit field
                    if(c_index == 1) {
                         this.$emit('edit', this.findRowObject(row) )
                    } else if(c_index < this.columns.length) {
                         this.$emit('select', this.findRowObject(row))
                    }
               });
          this.updateAddressTable();
        },
        watch: {
              addresses() {
                  this.updateAddressTable();
             }
        },
        methods: {

            /**
             *
             * @param rows {String[]}
             */
            concatFields(row) {
                const addressFields = {}
                for (const [idx, col] of this.allFields.entries()) {
                    addressFields[col] = row[idx + 1]
                }
                return {addressinfoid: row[0], deliveryaddress: concatAddressFields(addressFields)}

            },
            findRowObject(row) {
                 // first column is the address Key
                 const address = this.addresses.find(v => v.key == row.data()[0])
                 return address
            },
             updateAddressTable: function () {
                  const pusher = (v) => {
                       const columns = [v.key];
                       columns.push('<a href="#" title="edit"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" class="svg-icon--datatable position-relative t-1px"><path d="M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01zm-15.15-6.26S13 19.51 9.75 22.78c-.11.11-.17.28-.2.43-.06.32-.22 1.52-.34 2.47a.971.971 0 001.07 1.09c.79-.09 1.79-.2 2.41-.28.25-.03.46-.13.63-.31 3.18-3.19 10.93-11.03 10.93-11.03l-3.4-3.4zm.72-.7l3.38 3.38c.62-.63 1.8-1.82 2.45-2.47l-3.38-3.38c-.65.66-1.83 1.85-2.45 2.47z" fill="#3a3a39"/></svg></a>')
                       for (const name of this.allFields) {
                            columns.push(v[name]||"")
                       }
                       
                       return columns;
                  }
                  const result = this.addresses.map(pusher)
                  this.dataTable.clear();
                  this.dataTable.rows.add(result)
                  this.dataTable.draw()
             },
        }

    }
</script>

<style scoped>

</style>